export const getAvaliacaoErrorCode = pErro => {
  return (
    pErro?.code ||
    pErro?.error?.code ||
    pErro?.response?.data?.error?.code ||
    null
  );
};

export const isAvaliacaoEncerradaPorAcessoNegado = pErro => {
  const xCode = getAvaliacaoErrorCode(pErro);

  return (
    Number(xCode?.status) === 401 &&
    String(xCode?.source || '') === '4' &&
    String(xCode?.ref || '') === '107'
  );
};

export const isAvaliacaoAcessoNegado = pErro => {
  const xCode = getAvaliacaoErrorCode(pErro);
  const xStatus =
    xCode?.status ||
    pErro?.response?.status ||
    pErro?.status ||
    pErro?.response?.data?.status ||
    pErro?.response?.data?.statusCode;

  return Number(xStatus) === 401 || Number(xStatus) === 403;
};
